import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import AuthCheck from "@/views/Auth/AuthCheck.vue";
import AuthLogout from "@/views/Auth/AuthLogout.vue";
import Home from "@/views/Home/Home.vue";

import { IRealRootState } from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "auth-check",
    component: AuthCheck
  },
  {
    path: "/logout",
    name: "auth-logout",
    component: AuthLogout
  },
  {
    path: "/home",
    name: "home",
    component: Home
  },
  {
    path: "/lessons",
    name: "lessons",
    component: () => import("../views/Lessons/Lessons.vue")
  },
  {
    path: "/students",
    name: "students",
    component: () => import("../views/Students/Students.vue")
  },
  {
    path: "/students/add",
    name: "students-add",
    component: () => import("../views/Students/StudentsAdd.vue")
  },
  {
    path: "/students/import",
    name: "students-import",
    component: () => import("../views/Students/StudentsImport.vue")
  },
  {
    path: "/students/:studentId/edit",
    name: "students-edit",
    component: () => import("../views/Students/StudentsEdit.vue")
  },
  {
    path: "/teachers",
    name: "teachers",
    component: () => import("../views/Teachers/Teachers.vue")
  },
  {
    path: "/classes",
    name: "classes",
    component: () => import("../views/Classes/ClassesList.vue")
  },
  {
    path: "/classes/add",
    name: "add-class",
    component: () => import("../views/Classes/ClassesAdd.vue")
  },
  {
    path: "/classes/:classId/edit",
    name: "edit-class",
    component: () => import("../views/Classes/ClassEdit.vue")
  },
  {
    path: "/teachers/add",
    name: "teacher-add",
    component: () => import("../views/Teachers/TeachersAdd.vue")
  },
  {
    path: "/teachers/:teacherId/edit",
    name: "teacher-edit",
    component: () => import("../views/Teachers/TeachersEdit.vue")
  },
  {
    path: "/report-generator",
    name: "report-generator",
    component: () => import("../views/ReportGenerator/ReportGenerator.vue")
  },
  {
    path: "/report-generator/result",
    name: "report-generator-result",
    component: () =>
      import("../views/ReportGeneratorResult/ReportGeneratorResult.vue")
  },
  {
    path: "/report-generator/lesson/:lessonId",
    name: "report-generator-result-thumbnails",
    component: () => import("../views/ReportGenerator/ReportThumbnails.vue")
  },
  {
    path: "/grammar-to-go",
    name: "grammar-to-go",
    component: () => import("../views/GrammarToGo/VideosList.vue")
  },
  {
    path: "/video/:videoId",
    name: "video-screen",
    component: () => import("../views/VideoPlay.vue")
  },
  {
    path: "/knowledge-base",
    name: "knowledge-base",
    component: () => import("../views/KnowledgeBase/KnowledgeBase.vue")
  },
  {
    path: "/knowledge-base/:id",
    name: "knowledge-base-detail",
    component: () => import("../views/KnowledgeBase/KnowledgeBaseDetail.vue")
  },
  {
    path: "/subgroups",
    name: "subgroups",
    component: () => import("../views/Subgroups/DataSelection.vue")
  },
  {
    path: "/subgroups/:groupId/assign",
    name: "subgroups-assign",
    component: () => import("../views/Subgroups/UserAssignment.vue")
  }
];

const publicRoutesPaths = ["/", "/logout"];

const router = new VueRouter({
  mode: "history",
  routes
});

function isRoutePublic(path: string) {
  return publicRoutesPaths.includes(path);
}

// Guard for authentication:
router.beforeEach((to, from, next) => {
  const { userId, userAccessToken } = (store.state as IRealRootState).session;

  if (!isRoutePublic(to.path) && (!userId || !userAccessToken)) {
    next({
      path: "/",
      query: { redirect: to.path, t: to.query.t, ...to.query }
    });
  } else {
    next();
  }
});

export default router;
